import React, { FC } from 'react';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import { FooterLink } from '../../../../types/types';
import { FooterLinkModel } from '../../../../lib/shared-models/FooterLink.model';
import { googleClickCtaEvent } from '../../../../utils/analytics';
import CTAButton, { ctaEnums } from '../../../@shared/ctaButton';
import RoutableSitecoreLink from '../../../@shared/routableSitecoreLink';

const DealerLogin: FC<FooterLink> = (props) => {
  const model = new FooterLinkModel(props);
  return (
    <div className="dealer-login">
      {model.title && <RichText tag="div" field={model.title} className="dealer-login__content" />}
      {model.list?.length > 0 && (
        <CTAButton type={ctaEnums.primaryRed}>
          <RoutableSitecoreLink
            field={model.list[0]?.fields?.link}
            onClick={(): void => {
              googleClickCtaEvent(
                'Global Footer',
                model.list[0]?.fields?.link?.value?.title ?? model.list[0]?.fields?.link?.value?.text,
                model.list[0]?.fields?.link?.value?.title
              );
            }}
          />
        </CTAButton>
      )}
    </div>
  );
};

export default DealerLogin;
